import ds from 'Shared/ds';

class NvApi {

    static activity = data => ds.get(this.#const.ACTIVITY, data);

    static orders = data => ds.get(this.#const.ORDERS, data);

    static order = data => ds.get(this.#const.ORDER, data);

    static orderDetails = data => ds.get(this.#const.ORDER_DETAILS, data);

    static offers = data => ds.get(this.#const.OFFERS, data);

    static offer = id => ds.get(this.#const.OFFER, id);

    static offerDetails = data => ds.get(this.#const.OFFER_DETAILS, data);

    static contracts = data => ds.get(this.#const.CONTRACTS, data);

    static contract = id => ds.get(`${this.#const.CONTRACTS}/${id}`);

    static creditNotes = data => ds.get(this.#const.CREDITNOTES, data);

    static creditNote = id => ds.get(this.#const.CREDITNOTE, id);

    static creditNoteDetails = data => ds.get(this.#const.CREDITNOTE_DETAILS, data);

    static returns = data => ds.get(this.#const.RETURNS, data);

    static return = id => ds.get(this.#const.RETURN, id);

    static returnDetails = data => ds.get(this.#const.RETURN_DETAILS, data);

    static openItems = data => ds.get(this.#const.OPENITEMS, data);

    static openItem = id => ds.get(`${this.#const.OPENITEMS}/${id}`);

    static projects = data => ds.get(this.#const.PROJECTS, data);

    static projects = id => ds.get(this.#const.PROJECTS, id);

    static customIds = data => ds.get(this.#const.CUSTOMIDS, data);

    static orderChanged = result => { PubSub.publish(this.Events.ORDER_CHANGED, result); }

    static #const = {
        ACTIVITY: "/customer/activity/data",

        ORDER: "/customer/activity/data/order",
        ORDERS: "/customer/order/data",
        ORDER_DETAILS: "/customer/order/data",

        OFFER: "/customer/activity/data/offer",
        OFFERS: "/customer/offer/data",
        OFFER_DETAILS: "/customer/offer/data",

        CREDITNOTE: "/customer/activity/data/creditnote",
        CREDITNOTES: "/customer/creditnote/data",
        CREDITNOTE_DETAILS: "/customer/creditnote/data",

        RETURN: "/customer/activity/data/return",
        RETURNS: "/customer/return/data",
        RETURN_DETAILS: "/customer/return/data",

        CONTRACTS: "/customer/contract/data",
        OPENITEMS: "/customer/openitem/data",
        OPENITEMDETAILS: "/customer/openitem/detail/data",
        PROJECTS: "/customer/project/data",
        CUSTOMIDS: "/customer/customids/data",
        CUSTOMID_EDIT: "/customer/customids/edit"
    };

    static Events = {
        ORDER_CHANGED: "order-changed",
        ORDER_CREATE_RETURN: "order-create-return"
    };
}

export default NvApi;